import type { RampPart, Vec2 } from './definition';

export function pathLength(points: readonly Vec2[]): number {
  let length = 0;
  for (let i = 1; i < points.length; i++)
    length += Math.hypot(points[i]!.x - points[i - 1]!.x, points[i]!.y - points[i - 1]!.y);
  return length;
}

/** Constant-distance progress: a short segment cannot consume half a ride. */
export function pointAlongPath(points: readonly Vec2[], t: number): Vec2 {
  if (!points.length) return { x: 0, y: 0 };
  let distance = Math.max(0, Math.min(1, t)) * pathLength(points);
  for (let i = 1; i < points.length; i++) {
    const a = points[i - 1]!;
    const b = points[i]!;
    const span = Math.hypot(b.x - a.x, b.y - a.y);
    if (distance <= span && span > 0) {
      const local = distance / span;
      return { x: a.x + (b.x - a.x) * local, y: a.y + (b.y - a.y) * local };
    }
    distance -= span;
  }
  return { ...points.at(-1)! };
}

/** Returns meet the playfield instead of ending six units in the air. */
export function rampElevation(ramp: RampPart, t: number): number {
  return ramp.transport === 'orbit' ? 0 : Math.sin(Math.PI * Math.max(0, Math.min(1, t))) * 6;
}
